import { createFeatureSelector, createSelector } from '@ngrx/store';
import { CoreState } from '../reducers';

export const selectCoreState = createFeatureSelector<CoreState>('core');

export const selectNotification = createSelector(
  selectCoreState,
  (state: CoreState) => state.notification,
);

export const selectChangeAccount = createSelector(
  selectCoreState,
  (state: CoreState) => state.changeAccount,
);